import React, { Component } from "react";
import { Redirect } from "react-router-dom";
import { Link } from "react-router-dom";
import axios from "axios";
import AS from "./Service/Authentication";
import CS from "../../commons/services/Common";
import { ROUTES } from "../../commons/constants/routes/routes";
import { withTranslation } from "react-i18next";

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      username: sessionStorage.getItem("userId") || "",
      password: "",
      token: sessionStorage.getItem("token") || "",
      userInfo: {},
      hasLoginFailed: false,
      showSuccessMessage: false,
    };
  }

  componentDidMount() {
    document.body.className = "body-login";
    //this.test();
  }

  test = () => {
    var siteInfoInDB = ["M2413"];
    var config = {
      method: "get",
      url: "https://hs3.hyundai-es.co.kr/hismart/monitoring/total",
      headers: {
        "X-Auth-Token": "64259887-d925-41bc-aa48-a4eaac611b35",
        "X-APP": "HIWAY4VUETIFY",
        "X-LOGKEY": "2022060214082125014IWPMY4VUETIFY7343",
        "X-APIVERSION": "v1.0",
        Cookie: "SCOUTER=z3k3osa8dr8i7m",
      },
    };

    const runSites = [];
    const newSites = [];
    const stopSites = [];
    axios(config)
      .then((res) => {
        console.log(res);
        const datas = res.data.datas;
        for (var key in datas.sido) {
          const sido = datas.sido[key];
          sido.runList.some((w) => {
            if (w.run_status == "Run") {
              runSites.push(w);
              if (!siteInfoInDB.includes(w.SITE_ID)) {
                newSites.push(w);
              }
            } else {
              stopSites.push(w);
            }
          });
        }
        //console.log(runSites);
        //console.log(stopSites);
        console.log(newSites);
        //console.log(CS.getKeyValues(runSites, 'SITE_ID'))
      })
      .catch((error) => {
        console.log(error);
      });
  };

  keyPress = (event) => {
    if (event.key == "Enter") {
      this.loginClicked();
    }
  };

  handleChange = (event) => {
    this.setState({
      [event.target.name]: event.target.value,
    });
  };

  loginClicked = () => {
    const { t } = this.props;
    AS.executeJwtAuthenticationService(this.state.username, this.state.password)
      .then((res) => {
        let authorities = res.data.userInfo.authorities;

        let isOk = true;
        authorities.some((v) => {
          if (v.authority === "ROLE_USR") {
            isOk = false;
            return true;
          }
        });

        if (isOk) {
          this.setState({
            token: res.data.jwtToken,
            userInfo: res.data.userInfo,
          });
          AS.onJwtLoginSuccess(this.state.token, this.state.userInfo);
          this.props.history.push(ROUTES.HOME_MAIN);
          setTimeout(AS.logout, 30 * 60000);
        } else {
          CS.notification("warning", t("key661")); //"해당 유저(사용자)는 접근이 불가합니다."
        }
      })
      .catch(() => {
        this.setState({ showSuccessMessage: false });
        this.setState({ hasLoginFailed: true });
      });
  };

  render() {
    if (AS.isUserLoggedIn()) return <Redirect to={ROUTES.HOME_MAIN} />;
    const { t } = this.props;
    return (
      <>
        <section className="login">
          <div className="card">
            <h2 className="tit">
              <img src="/images/ctors/frame/head/logo_naxa.svg" alt="NEXA" />
            </h2>
            <h3 className="s-tit">{t("key662")}</h3>  
            <div className="form">
              {this.state.hasLoginFailed && (
                <div className="alert alert-warning">
                  {t("key663")}
                </div>
              )}
              {this.state.showSuccessMessage && <div>Login Sucessful</div>}
              <div className="id">
                <label htmlFor="id">{t("key664")}</label>
                <input
                  type="text"
                  name="username"
                  value={this.state.username}
                  onChange={this.handleChange}
                  placeholder={t("key664")}
                  autoFocus
                />
              </div>
              <div className="pw">
                <label htmlFor="pw">{t("key665")}</label>
                <input
                  type="password"
                  name="password"
                  value={this.state.password}
                  onChange={this.handleChange}
                  placeholder={t("key665")}
                  onKeyPress={this.keyPress}
                />
              </div>
              <div className="btn-area">
                <button className="btn" onClick={this.loginClicked}>
                  Login
                </button>
              </div>
            </div>
            <div className="foot">
              <input id="idCheck" type="checkbox" />
              <label htmlFor="idCheck">{t("key666")}</label>
            </div>
          </div>
        </section>
      </>
    );
  }
}

export default withTranslation()(Login);
